import { Link } from 'react-router-dom'

const lastUpdatedLabel = 'Last updated December 3, 2025'

export function PrivacyPolicyPage() {
  return (
    <main className="bg-white">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="space-y-3">
          <p className="text-sm font-semibold uppercase tracking-wide text-blue-700">
            Legal
          </p>
          <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
          <p className="text-sm text-gray-500">{lastUpdatedLabel}</p>
          <p className="text-base text-gray-600">
            This policy explains what information White Gi collects, how we use
            it to power your jiu-jitsu training, and the controls you have over
            your data inside the app.
          </p>
        </header>

        <div className="mt-10 space-y-10">
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              Data We Collect
            </h2>
            <p className="text-gray-600">
              We only collect the information required to run White Gi:
            </p>
            <ul className="list-disc space-y-2 pl-5 text-gray-600">
              <li>
                Account details from OAuth providers (name, email, avatar).
              </li>
              <li>Profile preferences such as belt, rank, and academy.</li>
              <li>
                Training data you add (moves, series, videos, tags,
                annotations).
              </li>
              <li>Product analytics like feature usage and device type.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              How We Use Information
            </h2>
            <p className="text-gray-600">
              Data is processed to deliver core product features, personalize
              training recommendations, secure your account, and send optional
              communications.
            </p>
            <ul className="list-disc space-y-2 pl-5 text-gray-600">
              <li>Maintain your library of saved moves and series.</li>
              <li>Recommend next steps or drills based on your progress.</li>
              <li>Send transactional emails you request.</li>
              <li>Monitor reliability, fraud, and abuse signals.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              How We Share Data
            </h2>
            <p className="text-gray-600">
              We only share information with service providers that help us run
              White Gi (hosting, analytics) or when required by law. We do not
              sell or rent personal data to third-party marketers.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              Retention & Security
            </h2>
            <p className="text-gray-600">
              Content stays in your account until you remove it or request
              deletion. Encrypted storage, role-based access, and audited
              infrastructure keep your files protected.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              Your Choices
            </h2>
            <p className="text-gray-600">
              You can export or delete content, update your profile, and
              contact us for additional data requests. For detailed
              terms governing the app, see our{' '}
              <Link
                to="/terms"
                className="text-blue-700 underline hover:text-blue-800"
              >
                Terms of Service
              </Link>
              .
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              Children's Data
            </h2>
            <p className="text-gray-600">
              White Gi is not directed to children under 13. We do not knowingly
              collect information from children, and we delete any such data if
              it is brought to our attention.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">Contact</h2>
            <p className="text-gray-600">
              Questions about privacy? Email{' '}
              <a
                href="mailto:karmbirchima@gmail.com"
                className="text-blue-700 underline hover:text-blue-800"
              >
                karmbirchima@gmail.com
              </a>{' '}
              and we will help.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}
